import React, { useState, useEffect } from "react";
import { Select } from "../../../ReactSelect/ReactSelect";
import { Label } from "reactstrap";
import { useQueryParams } from "use-query-params";
import { FilterModel as stateQueryModel } from "../filterModel";

const StateSelector = ({ label, statesServiced }) => {
    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState(null);
    const [filterItems, setFilterItems] = useQueryParams(stateQueryModel);

    useEffect(() => {
        if (statesServiced) {
            setOptions(
                statesServiced.map((state) => ({
                    label: state.stateName,
                    value: { type: "state", ...state },
                }))
            );
        }
    }, [statesServiced]);

    useEffect(() => {
        if (options) {
            if (filterItems?.stateId) {
                setInputValue(
                    options.find(
                        (option) => option.value.stateId === filterItems.stateId
                    )
                );
            } else {
                setInputValue(null);
            }
        }
    }, [options, filterItems]);

    return (
        <div className="w-100 mb-2" data-test="select-state">
            <Label>{label}</Label>
            <Select
                className="w-100 react-select"
                placeholder={label}
                value={inputValue}
                options={options}
                isClearable={true}
                onChange={(item) => {
                    setInputValue(item);
                    setFilterItems({
                        stateId: item?.value?.stateId,
                        nicheItemId: undefined,
                    });
                }}
            />
        </div>
    );
};

export default StateSelector;
